import { Navigate } from "react-router-dom";
import { isTokenValid } from "../services/authService";

export const PrivateRoute = ({ children }) => {
  console.log("Checking token validity...");
  const valid = isTokenValid();
  console.log("Token valid?", valid);
  return valid ? children : <Navigate to="/" replace />;
};
